module.exports = __webpack_public_path__ + "5950c1f991c7a2c456e183019f532c80.png";